(() => {
  function initializeStickyButton() {
    const stickyButtons = document.querySelectorAll(".harp-ff-sticky-buy");

    stickyButtons.forEach((sticky) => {
      const stickyButton = sticky.querySelector("button");
      const stickyLabel = stickyButton?.querySelector("span");
      const productFormId = stickyButton?.getAttribute("form");
      const productForm = productFormId ? document.getElementById(productFormId) : null;
      const productWrapper = sticky.closest(".harp-ff-product") || document;
      const mainSubmit =
        productForm?.querySelector('button[type="submit"]') ||
        productWrapper.querySelector(".product-form__submit");

      if (!stickyButton || !stickyLabel) return;

      const syncStickyButton = () => {
        if (!mainSubmit) {
          stickyLabel.textContent = "Add to cart";
          return;
        }

        const unavailable =
          mainSubmit.disabled ||
          mainSubmit.getAttribute("aria-disabled") === "true";
        const mainText = mainSubmit.textContent.trim().toLowerCase();

        stickyButton.disabled = unavailable;
        stickyButton.setAttribute("aria-disabled", unavailable ? "true" : "false");

        if (unavailable) {
          stickyLabel.textContent = mainText.includes("sold out")
            ? "Sold out"
            : "Unavailable";
        } else {
          stickyLabel.textContent = "Add to cart";
        }
      };

      syncStickyButton();

      if (mainSubmit) {
        new MutationObserver(syncStickyButton).observe(mainSubmit, {
          attributes: true,
          childList: true,
          subtree: true,
        });
      }

      productWrapper.addEventListener("change", () => {
        window.setTimeout(syncStickyButton, 50);
      });
    });
  }

  function initialize() {
    /*
      Important: do not automatically hide the Appstle editor notice.
      The previous version searched upward through the DOM and could hide
      the entire product-information area after the page finished loading.
      The notice is an editor preview message and is left untouched here.
    */
    initializeStickyButton();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
